module.exports = __webpack_public_path__ + "42bce302cec1b0e22eeae969d6992a9e.png";